
export default function Blog() {
    window.location.replace("https://blog.vendpark.io/blog");
}